import { Currency } from '@/core/real-estate/typings'

/**
 * Formats a complete price string with amount, label, and currency
 * @param amount - The numerical price amount
 * @param options - Formatting options
 * @returns Formatted price string
 */
interface PriceFormatOptions {
  label?: string
  currency?: Currency
  prefix?: string
  showPrefix?: boolean
}

export const formatPriceString = (
  amount: string | number,
  options: PriceFormatOptions = {}
): string => {
  const { label, currency, prefix = '$', showPrefix = true } = options

  const formattedAmount = amount.toLocaleString()
  const formattedLabel = label ? `/${label.toLowerCase()}` : ''
  const formattedCurrency = currency ? ` ${currency.toUpperCase()}` : ''
  const pricePrefix = showPrefix ? prefix : ''

  return `${pricePrefix}${formattedAmount}${formattedLabel}${formattedCurrency}`.trim()
}
